module.exports = __webpack_public_path__ + "img/117.1a67b53f.jpg";